// @ts-nocheck
import {Percent, CurrencyUSD, Time, GraphQLDecimal} from '@/graphql/scalars'

import * as Types from '../../../../types/schema';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GenerateDocumentSummariesReportMutationVariables = Types.Exact<{ [key: string]: never; }>;


export type GenerateDocumentSummariesReportMutation = { __typename?: 'Mutation', exportDocumentSummariesExcel: { __typename?: 'FileDownloadToken', token: string, expiresInSeconds: number } };

export const Operations = {
  Mutation: {
    GenerateDocumentSummariesReport: 'GenerateDocumentSummariesReport' as const
  }
}

/**
 * Custom plugin to wrap useQuery hooks with automatic context.fetchPolicy injection
 */
function withFetchPolicyContext(options) {
  const fetchPolicy = options?.fetchPolicy ?? 'cache-first';
  const isLazy = options?.isLazy ?? undefined;
  return {
    ...options,
    context: {
      ...options?.context,
      fetchPolicy,
      isLazy,
    },
  };
}

/**
 * Defaults useSubscription to ignoreResults: true so Apollo skips its
 * per-message useSyncExternalStore notification (forceStoreRerender). All
 * call sites manage state via onData; opting out avoids render storms when
 * messages arrive in a synchronous burst. See T2-10011. Callers that need
 * Apollo to surface data/loading/error can override by passing
 * ignoreResults: false explicitly.
 */
function withSubscriptionIgnoreResults(options) {
  return {
    ignoreResults: true,
    ...options,
  };
}


export const GenerateDocumentSummariesReportDocument = gql`
    mutation GenerateDocumentSummariesReport {
  exportDocumentSummariesExcel {
    token
    expiresInSeconds
  }
}
    `;
export type GenerateDocumentSummariesReportMutationFn = Apollo.MutationFunction<GenerateDocumentSummariesReportMutation, GenerateDocumentSummariesReportMutationVariables>;

/**
 * __useGenerateDocumentSummariesReportMutation__
 *
 * To run a mutation, you first call `useGenerateDocumentSummariesReportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateDocumentSummariesReportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateDocumentSummariesReportMutation, { data, loading, error }] = useGenerateDocumentSummariesReportMutation({
 *   variables: {
 *   },
 * });
 */
export function useGenerateDocumentSummariesReportMutation(baseOptions?: Apollo.MutationHookOptions<GenerateDocumentSummariesReportMutation, GenerateDocumentSummariesReportMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GenerateDocumentSummariesReportMutation, GenerateDocumentSummariesReportMutationVariables>(GenerateDocumentSummariesReportDocument, options);
      }
export type GenerateDocumentSummariesReportMutationHookResult = ReturnType<typeof useGenerateDocumentSummariesReportMutation>;
export type GenerateDocumentSummariesReportMutationResult = Apollo.MutationResult<GenerateDocumentSummariesReportMutation>;
export type GenerateDocumentSummariesReportMutationOptions = Apollo.BaseMutationOptions<GenerateDocumentSummariesReportMutation, GenerateDocumentSummariesReportMutationVariables>;